module.exports = __webpack_public_path__ + "img/camera_flight_placeholder_v.e52d8c25.png";